import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxSocialMediaIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9.8272 9.52478C10.548 9.52478 11.1328 8.94719 11.1328 8.23518 11.1328 7.52318 10.548 6.94558 9.8272 6.94558 9.1064 6.94558 8.5216 7.52318 8.5216 8.23518 8.5216 8.94719 9.1064 9.52478 9.8272 9.52478zM9.7616 10.3576C7.6776 10.3576 5.9824 12.0528 5.9824 14.1368 5.9824 14.3824 6.1816 14.5824 6.428 14.5824 6.6744 14.5824 6.8736 14.3832 6.8736 14.1368 6.8736 12.544 8.1696 11.248 9.7624 11.248H9.8824C11.4752 11.248 12.7712 12.544 12.7712 14.1368 12.7712 14.3824 12.9704 14.5824 13.2168 14.5824 13.4632 14.5824 13.6624 14.3832 13.6624 14.1368 13.6624 12.0528 11.9672 10.3576 9.8832 10.3576H9.7616zM17.5328 10.3416H16.2496V9.05839C16.2496 8.81279 16.0504 8.61279 15.804 8.61279 15.5576 8.61279 15.3584 8.81199 15.3584 9.05839V10.3416H14.0752C13.8296 10.3416 13.6296 10.5408 13.6296 10.7872 13.6296 11.0336 13.8288 11.2328 14.0752 11.2328H15.3584V12.4856C15.3584 12.7312 15.5576 12.9312 15.804 12.9312 16.0504 12.9312 16.2496 12.732 16.2496 12.4856V11.2328H17.5328C17.7784 11.2328 17.9784 11.0336 17.9784 10.7872 17.9784 10.5408 17.7792 10.3416 17.5328 10.3416z"
            fill="#222"
          />
          <path
            d="M6.212 3.53918C4.2448 3.53918 2.6496 5.13438 2.6496 7.10158V14.468C2.6496 16.4352 4.2448 18.0304 6.212 18.0304H8.992L11.0648 20.1032C11.3256 20.364 11.6672 20.4944 12.0096 20.4944C12.352 20.4944 12.6936 20.364 12.9544 20.1032L15.0272 18.0304H17.8072C19.7744 18.0304 21.3696 16.4352 21.3696 14.468V7.10158C21.3696 5.13438 19.7744 3.53918 17.8072 3.53918H6.212ZM20.4784 14.468C20.4784 15.9408 19.28 17.14 17.8064 17.14H14.6576L12.324 19.4736C12.2104 19.5872 12.0784 19.604 12.0088 19.604C11.9392 19.604 11.8072 19.5872 11.6936 19.4736L9.36 17.14H6.2112C4.7384 17.14 3.5392 15.9416 3.5392 14.468V7.10158C3.5392 5.62878 4.7376 4.42958 6.2112 4.42958H17.8064C19.2792 4.42958 20.4784 5.62798 20.4784 7.10158V14.468Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
